(function () {
  'use strict';

  function statusEl(form) { return form.querySelector('[data-pf-address-status]'); }
  function errorEl(form) { return form.querySelector('[data-pf-address-error]'); }

  function say(node, message, isError) {
    if (!node) return;
    node.textContent = message || '';
    node.hidden = !message;
    node.classList.toggle('is-error', !!isError);
  }

  function api() {
    return window.PFApi || null;
  }

  function countryCode(form, value) {
    var typed = (value || '').trim();
    var node = document.querySelector('[data-pf-country-codes]');
    if (/^[A-Za-z]{2}$/.test(typed)) return typed.toUpperCase();
    if (node) {
      try {
        var codes = JSON.parse(node.textContent);
        var name = Object.keys(codes).find(function (key) { return key.toLowerCase() === typed.toLowerCase(); });
        if (name) return codes[name];
      } catch (error) {}
    }
    return typed;
  }

  /* Address phones are Indian mobile numbers only: the field shows a fixed +91
     and holds the 10-digit number, kept that way by assets/pf-indian-phone.js. */
  function phoneHelper() {
    return window.PFIndianPhone || null;
  }

  function canonicalPhone(value) {
    var phone = phoneHelper();
    return phone ? phone.canonical(value) : String(value || '').trim();
  }

  function splitPhone(form, value) {
    var input = form.elements.namedItem('phone');
    var phone = phoneHelper();
    if (!input) return;
    if (phone) phone.fill(input, value);
    else input.value = value || '';
  }

  function payload(form) {
    var raw = {};
    new FormData(form).forEach(function (value, key) { raw[key] = value; });

    var fullName = (raw.full_name || '').trim();
    var first = (raw.first_name || '').trim();
    var last = (raw.last_name || '').trim();
    if (!first && fullName) {
      var split = fullName.indexOf(' ');
      first = split === -1 ? fullName : fullName.slice(0, split);
      last = split === -1 ? '' : fullName.slice(split + 1).trim();
    }

    var type = form.querySelector('[data-address-type]:checked');
    var label = type ? type.value : '';
    // The app accepts home | work | other; the form offers a "Friend" chip too.
    if (['home', 'work', 'friend', 'family', 'other'].indexOf(label) === -1) label = 'other';

    return {
      firstName: first,
      lastName: last,
      fullName: fullName || undefined,
      phone: canonicalPhone(raw.phone) || undefined,
      address1: (raw.address1 || '').trim(),
      address2: (raw.address2 || '').trim() || undefined,
      landmark: (raw.landmark || '').trim() || undefined,
      city: (raw.city || '').trim(),
      province: raw.province,
      zip: (raw.zip || '').trim(),
      countryCode: countryCode(form, raw.country) || raw.country,
      label: label,
      setAsDefault: !!form.querySelector('[name="is_default"]:checked')
    };
  }

  function fail(form, error) {
    var client = api();
    var applied = client ? client.applyFieldErrors(form, error.fields) : 0;
    form.classList.toggle('was-validated', applied > 0);
    say(errorEl(form), error.message, true);
    say(statusEl(form), '');
    var first = form.querySelector('[aria-invalid="true"]');
    if (first) {
      first.focus({ preventScroll: true });
      first.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else if (errorEl(form)) {
      errorEl(form).focus();
    }
  }

  function localErrors(form) {
    var errors = {};
    var value = function (name) {
      var field = form.elements.namedItem(name);
      return field ? String(field.value || '').trim() : '';
    };
    var fullName = value('full_name');
    var phoneProblem = phoneHelper()
      ? phoneHelper().error(value('phone'))
      : (/^[6-9]\d{9}$/.test(value('phone')) ? '' : form.dataset.pfPhoneRequired);
    var address1 = value('address1');
    var province = value('province');
    var city = value('city');
    var zip = value('zip');

    if (!fullName) errors.fullName = form.dataset.pfNameRequired;
    if (!address1) errors.address1 = form.dataset.pfAddressRequired;
    if (phoneProblem) errors.phone = phoneProblem;
    else {
      var phoneInput = form.elements.namedItem('phone');
      // The attribute is only rendered while phone OTP is on (Theme settings).
      if (form.dataset.pfPhoneVerificationRequired && (!phoneInput || phoneInput.dataset.pfContactVerified !== 'true')) {
        errors.phone = form.dataset.pfPhoneVerificationRequired;
      }
    }
    if (!province) errors.provinceCode = form.dataset.pfStateRequired;
    if (!city) errors.city = form.dataset.pfCityRequired;
    if (!/^[1-9]\d{5}$/.test(zip)) errors.zip = form.dataset.pfPincodeInvalid;
    return errors;
  }

  function showLocalErrors(form, fields) {
    var client = api();
    if (client) client.applyFieldErrors(form, fields);
    form.classList.add('was-validated');
    say(errorEl(form), form.dataset.pfValidationSummary, true);
    say(statusEl(form), '');
    var first = form.querySelector('[aria-invalid="true"]');
    if (first) {
      first.focus({ preventScroll: true });
      first.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function initForm(form) {
    if (form.dataset.pfBound === 'true') return;
    form.dataset.pfBound = 'true';
    var phoneInput = form.elements.namedItem('phone');
    if (phoneInput && phoneInput.value) splitPhone(form, phoneInput.value);
    if (window.PFAddressRegions) {
      window.PFAddressRegions.bind(form).catch(function (error) { fail(form, error); });
    }
    form.addEventListener('pf:address-region-error', function (event) {
      fail(form, event.detail);
    });
    form.addEventListener('input', function (event) {
      var field = event.target.closest('[data-pf-field]');
      if (!field || field.getAttribute('aria-invalid') !== 'true') return;
      var key = field.getAttribute('data-pf-field');
      field.classList.remove('is-invalid');
      field.removeAttribute('aria-invalid');
      var slot = form.querySelector('[data-pf-field-error="' + key + '"]');
      if (slot) {
        slot.textContent = '';
        slot.hidden = true;
      }
      if (!form.querySelector('[aria-invalid="true"]')) {
        form.classList.remove('was-validated');
        say(errorEl(form), '');
      }
    });
    var editId = new URLSearchParams(location.search).get('address');
    if (editId) {
      form.dataset.pfAddressLoading = 'true';
      form.querySelectorAll('[data-pf-bind-value]').forEach(function (input) { input.removeAttribute('data-pf-bind-value'); });
      var save = form.querySelector('[type="submit"]');
      if (save) save.disabled = true;
      var title = form.closest('[data-profile-address]').querySelector('h1');
      if (title) title.textContent = form.dataset.pfAddressEditTitle;
      var client = api();
      if (client && client.isConfigured()) client.get('/v1/me/addresses').then(function (result) {
        var address = (result.addresses || []).find(function (item) { return String(item.id) === editId; });
        if (!address) throw new Error(form.dataset.pfAddressMissing);
        var values = {
          full_name: [address.firstName, address.lastName].filter(Boolean).join(' '),
          phone: address.phone, address1: address.address1, address2: address.address2,
          landmark: address.landmark,
          city: address.city, province: address.provinceCode || address.province,
          zip: address.zip, country: address.countryCode || address.country
        };
        Object.keys(values).forEach(function (key) {
          var input = form.elements.namedItem(key);
          if (!input) return;
          if (input.tagName === 'SELECT' && values[key]) input.dataset.pfPendingValue = values[key];
          else input.value = values[key] || '';
        });
        splitPhone(form, values.phone);
        if (window.PFAccount && window.PFAccount.refreshContactState) {
          window.PFAccount.refreshContactState();
        }
        if (window.PFAddressRegions) {
          return window.PFAddressRegions.sync(form, { preserveCity: true }).then(function () { return address; });
        }
        return address;
      }).then(function (address) {
        form.querySelectorAll('[data-address-type]').forEach(function (radio) { radio.checked = radio.value === (address.label || 'other'); });
        form.elements.namedItem('is_default').checked = !!address.isDefault;
        form.dataset.pfAddressId = editId;
        form.dataset.pfAddressLoading = 'false';
        if (save) save.disabled = false;
      }).catch(function (error) { fail(form, error); });
      else say(errorEl(form), client ? client.NOT_CONNECTED_MESSAGE : form.dataset.pfAddressMissing, true);
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (form.dataset.pfSubmitting === 'true' || form.dataset.pfAddressLoading === 'true') return;

      var errors = localErrors(form);
      if (Object.keys(errors).length) {
        showLocalErrors(form, errors);
        return;
      }

      var client = api();
      if (!client || !client.isConfigured()) {
        say(
          errorEl(form),
          client ? client.NOT_CONNECTED_MESSAGE : 'Address service is not connected yet.',
          true
        );
        return;
      }

      var submit = form.querySelector('[type="submit"]');
      form.dataset.pfSubmitting = 'true';
      if (submit) submit.disabled = true;
      client.applyFieldErrors(form, null);
      say(errorEl(form), '');
      say(statusEl(form), 'Saving…');

      var data = payload(form);
      window.PFAddressRegions.resolve(data.countryCode, data.province, data.city, data.zip)
        .then(function (region) {
          var savedId = form.dataset.pfAddressId;
          return savedId ? client.patch('/v1/me/addresses/' + encodeURIComponent(savedId), Object.assign(data, region)) : client.post('/v1/me/addresses', Object.assign(data, region));
        })
        .then(function () {
          say(statusEl(form), 'Address saved.');
          var next = form.getAttribute('data-pf-address-success-url');
          var requested = new URLSearchParams(window.location.search).get('return_to');
          if (requested) {
            try {
              var destination = new URL(requested, window.location.origin);
              if (destination.origin === window.location.origin) next = destination.pathname + destination.search + destination.hash;
            } catch (error) {}
          }
          if (next) window.location.assign(next);
          else form.reset();
        })
        .catch(function (error) {
          fail(form, error);
        })
        .then(function () {
          form.dataset.pfSubmitting = 'false';
          if (submit) submit.disabled = false;
        });
    });
  }

  function initDelete(button) {
    if (button.dataset.pfBound === 'true') return;
    button.dataset.pfBound = 'true';

    button.addEventListener('click', function (event) {
      event.preventDefault();

      var id = button.getAttribute('data-pf-address-delete');
      var form = document.querySelector('[data-pf-address-form]');
      var client = api();

      if (!client || !client.isConfigured() || !id) {
        say(
          errorEl(form || document),
          client ? client.NOT_CONNECTED_MESSAGE : 'Address service is not connected yet.',
          true
        );
        return;
      }

      button.disabled = true;
      client
        .del('/v1/me/addresses/' + encodeURIComponent(id))
        .then(function () {
          var card = button.closest('[data-pf-address-card]');
          if (card) card.remove();
          else window.location.reload();
        })
        .catch(function (error) {
          button.disabled = false;
          say(errorEl(form || document), error.message, true);
        });
    });
  }

  function boot() {
    document.querySelectorAll('[data-pf-address-form]').forEach(initForm);
    document.querySelectorAll('[data-pf-address-delete]').forEach(initDelete);
  }

  /* The saved list is re-rendered from GET /v1/me/addresses for an app session
     (assets/pf-profile-hydrate.js), so its Delete buttons are younger than the
     first pass and have to be bound when they arrive. */
  document.addEventListener('pf:profile:hydrated', boot);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
